import { useLayoutEffect, useReducer } from 'react';

import debug from 'helpers/debug';

const log = debug('useStore');

const useStore = (store) => {
  const forceUpdate = useReducer((c) => c + 1, 0)[1];

  useLayoutEffect(() => {
    log(`Subscribing to ${store.name}`);
    const unsubscribe = store.subscribe(newState => {
      forceUpdate();
    });

    return () => {
      log(`Unsubscribing from ${store.name}`);
      unsubscribe();
    };
  }, [store, forceUpdate]);

  return store;
};

export default useStore;
